import { qs, rafThrottle } from '../utils/dom';

/**
 * Shadow on scroll, plus hide-on-scroll-down when the header is sticky
 * (Theme settings -> Header adds data-sticky).
 */
export const initHeader = () => {
  const header = qs('[data-header]');

  if (!header) {
    return;
  }

  let lastY = window.scrollY;
  const threshold = header.offsetHeight;
  const isSticky = 'sticky' in header.dataset;

  const onScroll = rafThrottle(() => {
    const y = window.scrollY;

    header.classList.toggle('is-scrolled', y > 8);

    // Ignore the menu-open state: a fixed overlay must not chase the scroll.
    if (isSticky && !document.body.classList.contains('is-menu-open')) {
      header.classList.toggle('is-hidden', y > lastY && y > threshold);
    }

    lastY = y;
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
};
